module.exports = __webpack_public_path__ + "static/media/checklist-aff.1816a5c5.svg";